import { render, staticRenderFns } from "./MaterialKeyInCategory.vue?vue&type=template&id=610dd5c0&scoped=true&"
import script from "./MaterialKeyInCategory.vue?vue&type=script&lang=js&"
export * from "./MaterialKeyInCategory.vue?vue&type=script&lang=js&"
import style0 from "./MaterialKeyInCategory.vue?vue&type=style&index=0&id=610dd5c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610dd5c0",
  null
  
)

export default component.exports